import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from "app/services/translate";

export const OtherColumn = ({competitor, deliberateRate, comparisonAmounts}) => (
    <div className="box box-other">
        <div className="other-branding">
            {competitor}
        </div>
        <div className="value">
            {deliberateRate.rate}
        </div>
        <div className="value">
            {Translate('comparison_values_fee')}
        </div>
        <div className="value">
            {Translate('comparison_values_delivery_time')}
        </div>
        <div className="value labeled">
            <div className="label">
                {Translate('commons_recipient_receive')}:
            </div>
            <div className="value-inside">
                {comparisonAmounts.other.toString}
            </div>
        </div>
        <div className="value">
            -
        </div>
    </div>
);

OtherColumn.propTypes = {
    competitor: PropTypes.string,
    deliberateRate: PropTypes.object,
    comparisonAmounts: PropTypes.object,
};
